import time from 'utils/time';
import useTopicOrClientWord from 'components/Dashboard/hooks/useTopicOrClientWord';
import { CrmContactImage } from 'components/Dashboard/Influence/CrmContacts/CrmContactsTable/CrmContactItem/CrmContactItem';
import { NoteVisibilityLogo } from 'components/Dashboard/StakeHolders/StakeholderPage/ui/BioSections/Notes';
import React, { useEffect, useRef, useState } from 'react';

const NotesPageListItem = (props) => {
  const { item, team, activePlan, user } = props;
  const { text, created, authorName, content, contentType, isOrganisationWide } = item;
  const { contentUrl, title, imageId } = content ?? {};

  const { newAgencyPlan } = useTopicOrClientWord();

  const [isExpandable, setIsExpandable] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef?.current?.scrollHeight > 68) {
      setIsExpandable(true);
    }
  }, [contentRef?.current]);

  const stakeholderNote = contentType === 'Stakeholder';

  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpand = () => {
    if (isExpandable) {
      setIsExpanded(!isExpanded);
      if (isExpanded) {
        setTimeout(() => {
          contentRef.current.classList.add('notes-page-list-item-content');
        }, 300);
      } else {
        contentRef.current.classList.remove('notes-page-list-item-content');
      }
    }
  };

  return (
    <div
      className={`bg-white ${
        isExpandable ? 'box-list-item' : ''
      } specific-x-padding-30 specific-bottom-padding-25 specific-top-padding-20 border-general border-grey rounded-15 specific-bottom-margin-20`}
      onClick={handleExpand}
    >
      <div className='d-flex align-items-center justify-content-between specific-bottom-margin-10'>
        <div className='d-flex align-items-center'>
          <p className='paragraph-p1 text-light-blue-100 mb-0'>{authorName}</p>
        </div>
        <div className='d-flex align-items-center'>
          <p className='paragraph-p1 text-main-blue-60 mb-0 '>{time(created).formatEmbargoedDateNoYear()}</p>
          {newAgencyPlan && (
            <NoteVisibilityLogo
              isOrganisationWide={isOrganisationWide}
              team={team}
              activePlan={activePlan}
              user={user}
              className='mr-0'
              style={{ transform: 'translateY(-2px)' }}
              showTooltip={true}
            />
          )}
        </div>
      </div>
      {stakeholderNote && (
        <div className='notes-page-stakeholder-image-container mr-2 d-inline-block specific-top-padding-6'>
          <CrmContactImage imageId={imageId} size='25px' />
        </div>
      )}
      <span className='font-weight-bold d-inline-block specific-bottom-margin-20 text-external-link '>
        <a
          href={contentUrl}
          className='paragraph-p1 link-main-blue text-main-blue text-underline-hover'
          target='_blank'
          rel='noreferrer'
        >
          {title}
        </a>
        <span className='icon-external-bold paragraph-p3-bold text-main-blue ml-2'></span>
      </span>

      <div
        className={`editor-content-preview border-left-2 border-main-blue pl-3 pb-0 transition-200 overflow-hidden notes-page-list-item-content`}
        style={{ maxHeight: isExpanded ? contentRef?.current?.scrollHeight + 'px' : '68px' }}
        ref={contentRef}
        dangerouslySetInnerHTML={{ __html: text }}
      ></div>
    </div>
  );
};

export default NotesPageListItem;
